var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { MPInstancesHub } from "@/api/RequestAxios/RequestAxiosHub";
import PublicRequester from "@/api/RequestAxios/RequestAxiosHubPublic";
import { packQueryParams } from "../utils";
import { UIModelPartners, UIModelPartner, UIModelFacebookBusinessAccountInfo, UIModelFilterOptions, UIModelPartnerUser, UIModelPartnerPaymentInfo, UIModelPartnerChangeRequestsInfo, UIModelInvoices } from "./partners.model";
import { unpackPartners, unpackPartner, packPartner, unpackFacebookBusinessAccountInfo, unpackFilterOptions, unpackPartnerUser, packPartnerUser, unpackAPIKey, unpackPartnerPaymentInfo, unpackPartnerChangeInfo, unpackPartnerChangeRequest, packRejectionData, packAccountSharingSettings, packLocalizationRegionSettings, packPartnerIntegrationData, unpackPartnerBillingData, packPartnerBillingData, packAuthSettings, packPartnerClientAccountCreation, unpackV2PartnerChangeRequest } from "./partners.mapper";
import { toJS } from "mobx";
import qs from "qs";
import removeNullValues from "@/utilities/removeNullValues";
import { packVATPayload, unpackPaymentSessionData } from "../clients/clients.mapper";
import { packParterAutoRechargeData, unpackPartnerBalance } from "../accounting/accounting.mapper";
import { generateIOSSecretURL, getIOSecretURL, toggleIOSignatureVerificationURL, validateIOSignatureURL } from "@/utilities/ioSignature";
var partnersURL = function () { return "/partners"; };
var partnerURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId);
};
var partnerBusinessInfoURL = function (_a) {
    var partnerId = _a.partnerId, fbBusinessId = _a.fbBusinessId;
    return "/partners/".concat(partnerId, "/info/facebook_account/").concat(fbBusinessId);
};
var partnerFilterOptionsURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/configs/filter_options");
};
var partnerPublicFilterOptionsURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/public_configs/filter_options");
};
var partnerUserURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/users");
};
var partnerAPIKeyURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/api_keys");
};
var partnerPaymentInfoURL = function (_a) {
    var partnerId = _a.partnerId, coupon = _a.coupon;
    return coupon
        ? "/partners/".concat(partnerId, "/data/public?coupon=").concat(coupon)
        : "/partners/".concat(partnerId, "/data/public");
};
var partnerChangeRequestURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/partner_change_requests");
};
var approvePartnerChangeURL = function (_a) {
    var clientId = _a.clientId, partnerId = _a.partnerId, partnerChangeRequestId = _a.partnerChangeRequestId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/partner_change_requests/").concat(partnerChangeRequestId, "/approve");
};
var rejectPartnerChangeURL = function (_a) {
    var clientId = _a.clientId, partnerId = _a.partnerId, partnerChangeRequestId = _a.partnerChangeRequestId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/partner_change_requests/").concat(partnerChangeRequestId, "/reject");
};
var singlePartnerChangeRequestURL = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, id = _a.id;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/partner_change_requests/").concat(id);
};
var partnerPaymentPlanURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/payment_plan");
};
var wehookEventUrl = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/send_test_webhook_event");
};
var accountSharingSettingsURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/settings/account_sharing");
};
var authSettingsURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/settings/auth");
};
var marketingTemplatesRoutingURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/settings/marketing_templates_routing");
};
var defaultDataLocalizationRegionUrl = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/settings/default_data_localization_region");
};
var getPartnerBillingDataUrl = function (_a) {
    var partnerId = _a.partnerId;
    return "partners/".concat(partnerId, "/pbs/billing_data");
};
var getPartnerBillingTermsUrl = function (_a) {
    var partnerId = _a.partnerId;
    return "partners/".concat(partnerId, "/pbs/billing_terms");
};
var revokeCancellationUrl = function (_a) {
    var partnerId = _a.partnerId;
    return "partners/".concat(partnerId, "/revoke_cancellation");
};
var getPartnerPaymentMethodsUrl = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/pbs/payment_methods");
};
var deactivatePaymentMethodUrl = function (_a) {
    var partnerId = _a.partnerId, paymentMethodId = _a.paymentMethodId;
    return "/partners/".concat(partnerId, "/pbs/payment_method/").concat(paymentMethodId, "/deactivate");
};
var reorderPaymentMethodUrl = function (_a) {
    var partnerId = _a.partnerId, paymentMethodId = _a.paymentMethodId;
    return "/partners/".concat(partnerId, "/pbs/payment_method/").concat(paymentMethodId, "/reorder");
};
var reorderAllPaymentMethodsUrl = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/pbs/payment_method/reorder_all");
};
var getPartnerInvoicesUrl = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/pbs/invoices");
};
var getPartnerInvoiceAsPDFUrl = function (_a) {
    var partnerId = _a.partnerId, invoiceId = _a.invoiceId;
    return "/partners/".concat(partnerId, "/pbs/invoices/").concat(invoiceId, "/pdf");
};
var getPartnerUnpaidInvoiceLinkUrl = function (_a) {
    var partnerId = _a.partnerId, invoiceId = _a.invoiceId;
    return "/partners/".concat(partnerId, "/pbs/invoices/").concat(invoiceId, "/payment-link");
};
var paymentSessionURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/pbs/add_payment_method");
};
var balanceSettingsURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/pbs/auto_recharge_settings");
};
var vatInfoUrl = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/set_vat_info");
};
var balanceURL = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/balance");
};
var getPartnerTransactionsUrl = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/pbs/balance/history");
};
var getPartnerBundlesUrl = function () { return "partners/pbs/bundles"; };
var getPartnerCatalogPlansUrl = function () { return "partners/pbs/plans"; };
var pbsInvoiceManualNewUrl = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/pbs/invoice/manual/new");
};
var pbsBankTransferInstructionsUrl = function () { return "pbs/bank_transfer/instructions"; };
var getPartnerClientCreateUrl = function (_a) {
    var partnerId = _a.partnerId;
    return "/partners/".concat(partnerId, "/account_sharing/clients");
};
var approveV2PartnerChangeRequestUrl = function (_a) {
    var clientId = _a.clientId, partnerId = _a.partnerId, partnerChangeRequestId = _a.partnerChangeRequestId;
    return "partners/".concat(partnerId, "/clients/").concat(clientId, "/selective_partner_change_requests/").concat(partnerChangeRequestId, "/approve");
};
var getV2PartnerChangeRequestUrl = function (_a) {
    var clientId = _a.clientId, partnerId = _a.partnerId, partnerChangeRequestId = _a.partnerChangeRequestId;
    return "/partners/".concat(partnerId, "/clients/").concat(clientId, "/selective_partner_change_requests/").concat(partnerChangeRequestId);
};
export var getPartners = function (queryParams) { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(partnersURL(), {
                    params: queryParams && packQueryParams(queryParams),
                    paramsSerializer: function (params) {
                        var filters = params.filters, otherParams = __rest(params, ["filters"]);
                        var serializedQueryString = qs.stringify(otherParams, {
                            arrayFormat: "repeat"
                        });
                        return "".concat(serializedQueryString, "&filters=").concat(JSON.stringify(toJS(filters)));
                    }
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, new UIModelPartners(unpackPartners(data))];
        }
    });
}); };
export var getPartner = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(partnerURL({ partnerId: partnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelPartner(unpackPartner(data))];
            }
        });
    });
};
export var addPartner = function (payload) { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(partnersURL(), packPartner(payload))];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, unpackPartner(data)];
        }
    });
}); };
export var getPartnerPaymentInfo = function (_a) {
    var partnerId = _a.partnerId, coupon = _a.coupon;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, PublicRequester.requester.get(partnerPaymentInfoURL({ partnerId: partnerId, coupon: coupon }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelPartnerPaymentInfo(unpackPartnerPaymentInfo(data))];
            }
        });
    });
};
export var validatePartnerExists = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var info, err_1, status;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getPartnerPaymentInfo({ partnerId: partnerId })];
                case 1:
                    info = _c.sent();
                    return [2 /*return*/, {
                            exists: true,
                            partnerName: info.brandName
                        }];
                case 2:
                    err_1 = _c.sent();
                    status = (_b = err_1 === null || err_1 === void 0 ? void 0 : err_1.response) === null || _b === void 0 ? void 0 : _b.status;
                    if (status === 404) {
                        return [2 /*return*/, { exists: false }];
                    }
                    return [2 /*return*/, { exists: false, error: err_1 }];
                case 3: return [2 /*return*/];
            }
        });
    });
};
export var editPartner = function (_a, payload) {
    var partnerId = _a.partnerId, integration = _a.integration;
    return __awaiter(void 0, void 0, Promise, function () {
        var payloadData, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    payloadData = integration
                        ? packPartnerIntegrationData(payload)
                        : packPartner(payload);
                    return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.patch(partnerURL({ partnerId: partnerId }), removeNullValues(payloadData))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelPartner(unpackPartner(data))];
            }
        });
    });
};
export var getFacebookBusinessAccountInfo = function (_a) {
    var partnerId = _a.partnerId, fbBusinessId = _a.fbBusinessId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(partnerBusinessInfoURL({
                        partnerId: partnerId,
                        fbBusinessId: fbBusinessId
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelFacebookBusinessAccountInfo(unpackFacebookBusinessAccountInfo(data))];
            }
        });
    });
};
export var getPartnerFilterOptions = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(partnerFilterOptionsURL({ partnerId: partnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelFilterOptions(unpackFilterOptions(data))];
            }
        });
    });
};
export var getPublicFilterOptions = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, PublicRequester.requester.get(partnerPublicFilterOptionsURL({ partnerId: partnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelFilterOptions(unpackFilterOptions(data))];
            }
        });
    });
};
export var addPartnerUser = function (_a, payload) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(partnerUserURL({ partnerId: partnerId }), packPartnerUser(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelPartnerUser(unpackPartnerUser(data))];
            }
        });
    });
};
export var addApiKey = function (_a, payload) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(partnerAPIKeyURL({ partnerId: partnerId }), {
                        phone_number: payload.phoneNumber
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackAPIKey(data)];
            }
        });
    });
};
export var triggerActivation = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var payload, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    payload = {};
                    return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post("".concat(partnerURL({ partnerId: partnerId }), "/control/trigger_activation"), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var approve = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var payload, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    payload = {};
                    return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post("".concat(partnerURL({ partnerId: partnerId }), "/control/approve"), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var addLogo = function (_a) {
    var file = _a.file, partnerId = _a.partnerId, onUploadProgress = _a.onUploadProgress;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post("".concat(partnerURL({ partnerId: partnerId }), "/control/upload_logo"), file, {
                        headers: { "Content-Type": "multipart/form-data" },
                        onUploadProgress: onUploadProgress
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelPartner(unpackPartner(data))];
            }
        });
    });
};
export var getPartnerChangeRequests = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(partnerChangeRequestURL({ partnerId: partnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelPartnerChangeRequestsInfo(unpackPartnerChangeInfo(data))];
            }
        });
    });
};
export var getSinglePartnerChangeRequest = function (_a) {
    var partnerId = _a.partnerId, clientId = _a.clientId, id = _a.id;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(singlePartnerChangeRequestURL({ partnerId: partnerId, clientId: clientId, id: id }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPartnerChangeRequest(data)];
            }
        });
    });
};
export var approvePartnerChangeRequest = function (_a) {
    var clientId = _a.clientId, partnerId = _a.partnerId, partnerChangeRequestId = _a.partnerChangeRequestId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(approvePartnerChangeURL({ clientId: clientId, partnerId: partnerId, partnerChangeRequestId: partnerChangeRequestId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPartnerChangeRequest(data)];
            }
        });
    });
};
export var rejectPartnerChangeRequest = function (_a) {
    var clientId = _a.clientId, partnerId = _a.partnerId, partnerChangeRequestId = _a.partnerChangeRequestId, payload = _a.payload;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(rejectPartnerChangeURL({ clientId: clientId, partnerId: partnerId, partnerChangeRequestId: partnerChangeRequestId }), packRejectionData(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPartnerChangeRequest(data)];
            }
        });
    });
};
export var getPartnerPaymentPlan = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(partnerPaymentPlanURL({ partnerId: partnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var updatePartnerPaymentPlan = function (_a) {
    var partnerId = _a.partnerId, bundleId = _a.bundleId, intent = _a.intent;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.patch(partnerPaymentPlanURL({ partnerId: partnerId }), __assign({ bundle_id: bundleId }, (intent ? { intent: intent } : {})))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var cancelSubscription = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.delete(partnerPaymentPlanURL({ partnerId: partnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var sendWebhookEvent = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(wehookEventUrl({ partnerId: partnerId }))];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
};
export var editAccountSettings = function (_a, payload) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.patch(accountSharingSettingsURL({ partnerId: partnerId }), packAccountSharingSettings(payload))];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
};
export var editAuthSettings = function (_a, payload) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.patch(authSettingsURL({ partnerId: partnerId }), packAuthSettings(payload))];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
export var editMarketingTemplatesRouting = function (_a, payload) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.patch(marketingTemplatesRoutingURL({ partnerId: partnerId }), {
                        use_marketing_messages_api: payload.useMarketingMessagesApi
                    }, {
                        skipGlobalLoader: true
                    })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
export var editLocalizationRegion = function (_a, payload) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.patch(defaultDataLocalizationRegionUrl({ partnerId: partnerId }), packLocalizationRegionSettings(payload))];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
export var getPartnerPaymentMethods = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getPartnerPaymentMethodsUrl({ partnerId: partnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data.data];
            }
        });
    });
};
export var getPartnerBillingData = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getPartnerBillingDataUrl({ partnerId: partnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var revokeCancellation = function (_a) {
    var partnerId = _a.partnerId, bundleId = _a.bundleId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(revokeCancellationUrl({ partnerId: partnerId }), { bundle_id: bundleId })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var billingTerms = function (_a, payload) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(getPartnerBillingTermsUrl({ partnerId: partnerId }), packPartnerBillingData(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPartnerBillingData(data)];
            }
        });
    });
};
export var updatePartnerBillingData = function (_a, payload) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(getPartnerBillingDataUrl({ partnerId: partnerId }), payload)];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var updatePartnerBillingDataWithTerms = function (_a, payload) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(getPartnerBillingTermsUrl({ partnerId: partnerId }), packPartnerBillingData(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPartnerBillingData(data)];
            }
        });
    });
};
export var getPartnerInvoices = function (_a) {
    var partnerId = _a.partnerId, page = _a.page, limit = _a.limit, sortBy = _a.sortBy, sortOrder = _a.sortOrder, status = _a.status, billDateTo = _a.billDateTo, billDateFrom = _a.billDateFrom;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getPartnerInvoicesUrl({ partnerId: partnerId }), {
                        params: {
                            page: page,
                            limit: limit,
                            sortBy: sortBy,
                            sortOrder: sortOrder,
                            status: status,
                            billDateTo: billDateTo,
                            billDateFrom: billDateFrom
                        },
                        paramsSerializer: function (params) {
                            var parts = [];
                            Object.keys(params).forEach(function (key) {
                                var value = params[key];
                                if (Array.isArray(value)) {
                                    value.forEach(function (val) {
                                        parts.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(val)));
                                    });
                                }
                                else if (value !== undefined && value !== null) {
                                    parts.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value)));
                                }
                            });
                            return parts.join("&");
                        }
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, new UIModelInvoices(data)];
            }
        });
    });
};
export var getPartnerInvoiceAsPDF = function (_a) {
    var partnerId = _a.partnerId, invoiceId = _a.invoiceId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getPartnerInvoiceAsPDFUrl({ partnerId: partnerId, invoiceId: invoiceId }), {
                        responseType: "blob"
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getPartnerUnpaidInvoiceLink = function (_a) {
    var partnerId = _a.partnerId, invoiceId = _a.invoiceId, paymentMethodId = _a.paymentMethodId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getPartnerUnpaidInvoiceLinkUrl({ partnerId: partnerId, invoiceId: invoiceId }), {
                        params: {
                            paymentMethodId: paymentMethodId
                        }
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getPartnerPaymentSession = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(paymentSessionURL({ partnerId: partnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPaymentSessionData(data)];
            }
        });
    });
};
export var getPartnerBalanceSettings = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(balanceSettingsURL({ partnerId: partnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var updatePartnerBalanceSettings = function (_a) {
    var partnerId = _a.partnerId, payload = _a.payload;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(balanceSettingsURL({ partnerId: partnerId }), packParterAutoRechargeData(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var updateBusinessVAT = function (_a, payload) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(vatInfoUrl({ partnerId: partnerId }), packVATPayload(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getPartnerBalance = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(balanceURL({ partnerId: partnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackPartnerBalance(data)];
            }
        });
    });
};
export var getPartnerTransactions = function (_a) {
    var partnerId = _a.partnerId, granularity = _a.granularity, fromDate = _a.fromDate, untilDate = _a.untilDate, page = _a.page, limit = _a.limit, currency = _a.currency;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getPartnerTransactionsUrl({ partnerId: partnerId }), {
                        params: {
                            granularity: granularity,
                            from: fromDate,
                            to: untilDate,
                            page: page,
                            limit: limit,
                            currency: currency
                        }
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getPartnerBundles = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getPartnerBundlesUrl())];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data === null || data === void 0 ? void 0 : data.bundles];
            }
        });
    });
};
export var getPartnerCatalogPlans = function () { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getPartnerCatalogPlansUrl())];
            case 1:
                data = (_b.sent()).data;
                return [2 /*return*/, (_a = data === null || data === void 0 ? void 0 : data.plans) !== null && _a !== void 0 ? _a : []];
        }
    });
}); };
export var createPartnerClientAccount = function (_a, payload) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(getPartnerClientCreateUrl({ partnerId: partnerId }), packPartnerClientAccountCreation(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var approveV2PartnerChangeRequest = function (_a) {
    var clientId = _a.clientId, partnerId = _a.partnerId, partnerChangeRequestId = _a.partnerChangeRequestId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(approveV2PartnerChangeRequestUrl({
                        clientId: clientId,
                        partnerId: partnerId,
                        partnerChangeRequestId: partnerChangeRequestId
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackV2PartnerChangeRequest(data)];
            }
        });
    });
};
export var getV2PartnerChangeRequest = function (_a) {
    var clientId = _a.clientId, partnerId = _a.partnerId, partnerChangeRequestId = _a.partnerChangeRequestId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getV2PartnerChangeRequestUrl({
                        clientId: clientId,
                        partnerId: partnerId,
                        partnerChangeRequestId: partnerChangeRequestId
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackV2PartnerChangeRequest(data)];
            }
        });
    });
};
export var deactivatePartnerPaymentMethod = function (_a) {
    var partnerId = _a.partnerId, paymentMethodId = _a.paymentMethodId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(deactivatePaymentMethodUrl({
                        partnerId: partnerId,
                        paymentMethodId: paymentMethodId
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var reorderPartnerPaymentMethod = function (_a) {
    var partnerId = _a.partnerId, paymentMethodId = _a.paymentMethodId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(reorderPaymentMethodUrl({
                        partnerId: partnerId,
                        paymentMethodId: paymentMethodId
                    }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var reorderAllPartnerPaymentMethods = function (_a) {
    var partnerId = _a.partnerId, items = _a.items;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(reorderAllPaymentMethodsUrl({
                        partnerId: partnerId
                    }), { items: items })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var createPbsManualInvoice = function (_a) {
    var partnerId = _a.partnerId, fsAccountId = _a.fsAccountId, amount = _a.amount, currency = _a.currency, reason = _a.reason;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(pbsInvoiceManualNewUrl({ partnerId: partnerId }), {
                        fsAccountId: fsAccountId,
                        amount: amount,
                        currency: currency,
                        reason: reason
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data.data];
            }
        });
    });
};
export var getBankTransferInstructions = function () { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(pbsBankTransferInstructionsUrl())];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data === null || data === void 0 ? void 0 : data.data];
        }
    });
}); };
export var validateIOSignature = function (_a) {
    var partnerId = _a.partnerId, io_signature = _a.io_signature, io_timestamp = _a.io_timestamp;
    return __awaiter(void 0, void 0, Promise, function () {
        var data, message, valid;
        var _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(validateIOSignatureURL({ partnerId: partnerId }), { io_signature: io_signature, io_timestamp: io_timestamp })];
                case 1:
                    data = (_g.sent()).data;
                    message = (_c = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : data === null || data === void 0 ? void 0 : data.message;
                    valid = typeof ((_d = data === null || data === void 0 ? void 0 : data.data) === null || _d === void 0 ? void 0 : _d.valid) === "boolean"
                        ? data.data.valid
                        : typeof (data === null || data === void 0 ? void 0 : data.valid) === "boolean"
                            ? data.valid
                            : false;
                    return [2 /*return*/, { valid: valid, message: message, error: (_f = (_e = data === null || data === void 0 ? void 0 : data.data) === null || _e === void 0 ? void 0 : _e.error) !== null && _f !== void 0 ? _f : data === null || data === void 0 ? void 0 : data.error }];
            }
        });
    });
};
export var toggleIOSignatureVerification = function (_a) {
    var partnerId = _a.partnerId, enabled = _a.enabled, otpCode = _a.otpCode;
    return __awaiter(void 0, void 0, Promise, function () {
        var requestBody, resp;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    requestBody = {
                        io_signature_verification_enabled: enabled
                    };
                    if (otpCode) {
                        requestBody.otp_code = otpCode;
                    }
                    return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.patch(toggleIOSignatureVerificationURL({ partnerId: partnerId }), requestBody)];
                case 1:
                    resp = (_c.sent()).data;
                    return [2 /*return*/, {
                            ioSignatureVerificationEnabled: resp === null || resp === void 0 ? void 0 : resp.data.io_signature_verification_enabled,
                            isEnabled: (_b = resp === null || resp === void 0 ? void 0 : resp.data) === null || _b === void 0 ? void 0 : _b.io_signature_verification_enabled
                        }];
            }
        });
    });
};
export var generateIOSSecret = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, void 0, function () {
        var data, err_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(generateIOSSecretURL({ partnerId: partnerId }))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
                case 2:
                    err_2 = _b.sent();
                    console.error("generateIOSSecret - request error", err_2);
                    throw err_2;
                case 3: return [2 /*return*/];
            }
        });
    });
};
/** OTP-protected; requires security:manage (partner owner). */
export var getIOSecret = function (_a) {
    var partnerId = _a.partnerId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data, payload;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get(getIOSecretURL({ partnerId: partnerId }))];
                case 1:
                    data = (_c.sent()).data;
                    payload = (_b = data === null || data === void 0 ? void 0 : data.data) !== null && _b !== void 0 ? _b : data;
                    return [2 /*return*/, payload];
            }
        });
    });
};
//# sourceMappingURL=data:application/json;base64,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